import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const Row = ({ row, measureType }) => {

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell component="th" scope="row">
          {row.month}
        </TableCell>
        {measureType == 'metric' ? (
          <>
            <TableCell align="right">{row.seconds}</TableCell>
            <TableCell align="right">{row.images}</TableCell>
            <TableCell align="right">{row.chars}</TableCell>
          </>
        ) : (
          <>
            <TableCell align="right">{row.video}</TableCell>
            <TableCell align="right">{row.audio}</TableCell>
            <TableCell align="right">{row.image}</TableCell>
            <TableCell align="right">{row.text}</TableCell>
          </>
        )}
        
      </TableRow>
    </React.Fragment>
  );
}

export const UsageTable = ({userUsage, measureType}) => {
  return (
    <TableContainer component={Paper} sx={{margin: "5% 0"}}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Month</TableCell>
            {measureType == 'metric' ? (
              <>
                <TableCell align="right">Video/Audio (seconds)</TableCell>
                <TableCell align="right">Images</TableCell>
                <TableCell align="right">Text (characters)</TableCell>
              </>
            ) : (
              <>
                <TableCell align="right">Videos</TableCell>
                <TableCell align="right">Audios</TableCell>
                <TableCell align="right">Images</TableCell>
                <TableCell align="right">Documents</TableCell>
              </>
            )}
            
          </TableRow>
        </TableHead>
        <TableBody>
          {userUsage.map((row) => (
            <Row key={row.month} row={row} measureType={measureType} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}